/**
 * API search types - These values must match the API expectations exactly
 * Used for searchType parameter in API requests
 */
export enum SearchType {
  TEXT = "text",
  IMAGE_URL = "image-url",
  IMAGE_DATA = "image-data",
  LOCATION = "location",
}
